const centersPathname = {
  CENTERS: '/app/centers',
  DATA: (id) =>
    centersPathname.CENTERS + '/' + ownCentersPathname.OWN + `/${id}/data`,
}

const mainCentersPathname = {
  // CENTERS: centersPathname.CENTERS + `/main`,
  OWNER: centersPathname.CENTERS + `/own`,
  FRANCHISE: centersPathname.CENTERS + `/franchise`,
  OTHER: centersPathname.CENTERS + `/other`,

  DATA: (id) => centersPathname.CENTERS + `/${id}/data`,
  COMERCIAL_DATA_ALL: (id) => centersPathname.CENTERS + `/${id}/comercial-data`,
  COMERCIAL_DATA: ({ id, idComercialData }) =>
    centersPathname.CENTERS + `/${id}/comercial-data/${idComercialData}`,
  WORKERS: (id) => centersPathname.CENTERS + `/${id}/workers`,
  CONTRACTS: (id) => centersPathname.CENTERS + `/${id}/contracts`,
  CONVENTIONS: (id) => centersPathname.CENTERS + `/${id}/conventions`,
  SERVICES: (id) => centersPathname.CENTERS + `/${id}/services`,
  MAINTENANCES: (id) => centersPathname.CENTERS + `/${id}/maintenances`,

  CASH_REGISTERS: (id) => centersPathname.CENTERS + `/${id}/cash-registers`,
  CASH_REGISTERS_EDIT: (id) =>
    centersPathname.CENTERS + `/${id}/cash-registers/edit`,

  TECHNICS: (id) => centersPathname.CENTERS + `/${id}/technics`,
  MANUALS: (id) => centersPathname.CENTERS + `/${id}/manuals`,
}

// @DEPRECATED

const ownCentersPathname = {
  // TODO: Remove following line
  OWN: 'own',
  OWN_PATH: `${centersPathname.CENTERS}/own`,
}

const otherCentersPathname = {
  OTHER: 'other',
  OTHER_PATH: `${centersPathname.CENTERS}/other`,
}

const ensenyaCentersPathname = {
  // TODO: Remove following line
  ENSENYA: 'ensenya',
  ENSENYA_PATH: `${centersPathname.CENTERS}/ensenya`,
}

const centersManuals = {
  // TODO: Remove following line
  MANUALS: 'manuals',
  MANUALS_PATH: `${centersPathname.CENTERS}/manuals`,
}

const franchiseCentersPathname = {
  // TODO: Remove following line
  FRANCHISE: 'franchise',
  FRANCHISE_PATH: `${centersPathname.CENTERS}/franchise`,
}

// Centro propio
const ownCenterPathname = {
  DATA: (id) =>
    centersPathname.CENTERS + '/' + ownCentersPathname.OWN + `/${id}/data`,
  SERVICES: (id) =>
    centersPathname.CENTERS + '/' + ownCentersPathname.OWN + `/${id}/services`,
  TECHNICAL_DATA: (id) =>
    centersPathname.CENTERS + '/' + ownCentersPathname.OWN + `/${id}/technical`,
  EMPLOYEES: (id) =>
    centersPathname.CENTERS + '/' + ownCentersPathname.OWN + `/${id}/employees`,
  EXTERNAL_COMPANIES: (id) =>
    centersPathname.CENTERS +
    '/' +
    ownCentersPathname.OWN +
    `/${id}/external_companies`,
  MANUALS: (id) =>
    centersPathname.CENTERS + '/' + ownCentersPathname.OWN + `/${id}/manuals`,
  MAINTENANCE: (id) =>
    centersPathname.CENTERS +
    '/' +
    ownCentersPathname.OWN +
    `/${id}/maintenance`,
  CASH: (id) =>
    centersPathname.CENTERS + '/' + ownCentersPathname.OWN + `/${id}/cash`,
}

const otherCenterPathname = {
  DATA: (id) =>
    centersPathname.CENTERS + '/' + otherCentersPathname.OTHER + `/${id}/data`,
  BUSINESS: (id) =>
    centersPathname.CENTERS +
    '/' +
    otherCentersPathname.OTHER +
    `/${id}/business`,
  SERVICES: (id) =>
    centersPathname.CENTERS +
    '/' +
    otherCentersPathname.OTHER +
    `/${id}/services`,
  TECHNICAL_DATA: (id) =>
    centersPathname.CENTERS +
    '/' +
    otherCentersPathname.OTHER +
    `/${id}/technical`,
  CONTRACTS: (id) =>
    centersPathname.CENTERS +
    '/' +
    otherCentersPathname.OTHER +
    `/${id}/contracts`,
  MANUALS: (id) =>
    centersPathname.CENTERS +
    '/' +
    otherCentersPathname.OTHER +
    `/${id}/manuals`,
}

const franchiseCenterPathname = {
  DATA: (id) =>
    centersPathname.CENTERS +
    '/' +
    franchiseCentersPathname.FRANCHISE +
    `/${id}/data`,
  BUSINESS: (id) =>
    centersPathname.CENTERS +
    '/' +
    franchiseCentersPathname.FRANCHISE +
    `/${id}/business`,
  SERVICES: (id) =>
    centersPathname.CENTERS +
    '/' +
    franchiseCentersPathname.FRANCHISE +
    `/${id}/services`,
  TECHNICAL_DATA: (id) =>
    centersPathname.CENTERS +
    '/' +
    franchiseCentersPathname.FRANCHISE +
    `/${id}/technical`,
  CONTRACTS: (id) =>
    centersPathname.CENTERS +
    '/' +
    franchiseCentersPathname.FRANCHISE +
    `/${id}/contracts`,
  MANUALS: (id) =>
    centersPathname.CENTERS +
    '/' +
    franchiseCentersPathname.FRANCHISE +
    `/${id}/manuals`,
}

export {
  mainCentersPathname,
  centersPathname,
  ownCentersPathname,
  ownCenterPathname,
  otherCentersPathname,
  otherCenterPathname,
  franchiseCentersPathname,
  franchiseCenterPathname,
  ensenyaCentersPathname,
  centersManuals,
}
